import { ActionWidget, ActionWidgetProps, RuntimeAction, SPI, Widget } from '@kunlun/dependencies';
import Comp from './BindActivityItemNavs.vue';

interface ActivityNavRelRecord {
  id?: number | string;
  sideNavId?: number | string;
  sideNavCode?: string;
  sideNavName?: string;
  sideNavSort?: number;
  horizontalNavId?: number | string;
  horizontalNavCode?: string;
  horizontalNavName?: string;
  horizontalNavSort?: number;
}

interface ActivityItemNavRelRecord {
  activityItemId?: number | string;
  activityCode?: string;
  itemTplId?: number | string;
  itemTplOutCode?: string;
  sideNavCode?: string;
  horizontalNavCode?: string;
}

interface ActivityItemRecord {
  id?: number | string;
  activityCode?: string;
  itemTplId?: number | string;
  outCode?: string;
  sideNavCodes?: string;
  navDisplayText?: string;
  navRelList?: ActivityItemNavRelRecord[];
}

@SPI.ClassFactory(
  ActionWidget.Token({
    model: 'deli.aries.settlement.DeliAriesCmActivityItem',
    name: 'uiViewe4d636535d5f497794dd3efe7d5a2abc'
  })
)
export class BindActivityItemNavsAction extends ActionWidget {
  public initialize(props: ActionWidgetProps<RuntimeAction>) {
    super.initialize(props);
    this.setComponent(Comp);
    return this;
  }

  @Widget.Method()
  public getCurrentPageNavConfigs() {
    const formData = this.rootData?.[0] || {};
    return (formData.navConfigList || formData.navRelList || []) as ActivityNavRelRecord[];
  }

  @Widget.Method()
  public applyNavsToSelectedRows(navConfigs: ActivityNavRelRecord[]) {
    const selectedRows = (this.activeRecords || []) as ActivityItemRecord[];
    if (!selectedRows.length) {
      return;
    }

    const sideNavCodes = navConfigs
      .map((item) => item.sideNavCode)
      .filter(Boolean)
      .join(',');
    const navDisplayText = navConfigs
      .map((item) => `${item.sideNavName || ''}(${item.sideNavCode || ''})`)
      .join(',');
    const rowIdSet = new Set(selectedRows.map((item) => item.id));

    const nextDataSource = ((this.dataSource || []) as ActivityItemRecord[]).map((item) => {
      if (!rowIdSet.has(item.id)) {
        return item;
      }

      const navRelList = navConfigs.map<ActivityItemNavRelRecord>((nav) => ({
        activityItemId: item.id,
        activityCode: item.activityCode,
        itemTplId: item.itemTplId,
        itemTplOutCode: item.outCode,
        sideNavCode: nav.sideNavCode,
        sideNavName: nav.sideNavName
      }));

      item.sideNavCodes = sideNavCodes || undefined;
      item.navDisplayText = navDisplayText || undefined;
      item.navRelList = navRelList;
      return item;
    });

    this.reloadDataSource(nextDataSource as any);
    this.refreshCallChaining?.syncCall(true);
  }
}
